<template>
	<div class="page" data-name="payment-list">
		<f7-navbar>
			<f7-nav-left>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
			</f7-nav-left>
			<div class="title">
				결제 내역 조회
			</div>
			<f7-nav-right>
				<f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
			</f7-nav-right>
		</f7-navbar>
			<!--상품 목록-->		
		<div class="page-content  infinite-scroll-content">
			<div class="list">
				<ul>
					<li class="item-content item-input">
						<div class="item-inner">
							<div class="item-title item-label">결제 상태</div>
							<div class="item-input-wrap input-dropdown-wrap">						
								<select placeholder="-결제상태를 선택하세요-" v-model="orderStatus" @change="onOrderStatusChanged">
									<option value="">-전체-</option>
									<template v-for="(item, i) in orderStatusList">
										<option :key="'i'+i" :value="item.id">{{item.name}}</option>
									</template>
								</select>						
							</div>
						</div>
					</li>
				</ul>
			</div>	

			<!--리스트 -->
			<div class="list">
				<ul>
					<template v-for="(item, i) in paymentResultList">
						<li :key="'ii' + i">
							<div class="item-content item-inner">
								<div class="item-title" style="cursor:pointer" v-on:click="showPayInfo(i)">
									<div class="item-header">
										<small>{{displayUpdataTime(item.ORDER_DATETIME)}}</small>
									</div>
									<span>
										{{item.ORDER_NAME}} 
									</span>
									<span v-if="item.PRODUCT_CNT > 1"> 외 ({{item.PRODUCT_CNT}}) 건</span>
								</div>										
								<div class="item-after">									
									<span class="badge" 
										:class="[{'color-blue': item.ORDER_STATUS == 'paid'},
														{'color-green': item.ORDER_STATUS == 'paying'}]">
										{{getOrderStatus(i)}}
									</span>									
								</div>
							</div>
						</li>
					</template>
				</ul>
			</div>
		</div>
		<div class="preloader infinite-scroll-preloader" style="display:none"></div>

	</div>
</template>
<script>
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';
import AUTH from '../../../js/common/auth.js'


export default {
	data() {
    return {  
			pageNo: 1,
			pageSize: 20,  
			paymentResultList: [],
			orderStatusList: [],
			orderStatus:"",
			allowInfinite: true,
			maxPageNo: 0
    }
  },
  mounted() {
		const _this = this;
		$('.infinite-scroll-content').on('infinite', _this.onInfinite);
		_this.setOrderStatus();
		$(document).on('page:init page:reinit', '.page[data-name="payment-list"]', this.onPageShow);
		//_this.loadPaymentResultList();
		setTimeout(function() {
				//
		}, 300);
  },
  methods: {
		onPageShow(e) {
			const _this = this;
			var page = e.detail;

			if(page.direction == "forward") {
				_this.loadPaymentResultList(1);
			}else if(page.direction == "backward") {
				
				var returnObj = PAGES.getReturnObj();	

				if(returnObj != undefined) {
					if(returnObj.code == "NEED_REFRESH") {
						_this.loadPaymentResultList(1);
					}
				}
			}
		},
		onInfinite() {
			const _this = this;

			if(!_this.allowInfinite) {
				return;
			}

			_this.allowInfinite = false;
			
			$('.infinite-scroll-preloader').show();

			setTimeout(function () {
				_this.allowInfinite = true;

				if(_this.page >= _this.maxPageNo) {
					_this.$f7.infiniteScroll.destroy('.infinite-scroll-content');
					$('.infinite-scroll-content').remove();
					return;
				}

				var newPageNo = _this.pageNo + 1;
				_this.loadPaymentResultList(newPageNo);

			}, 1000);

		},
		displayUpdataTime(updateTime) {
			var formatDate = moment(updateTime).format("YY.MM.DD");			
			return formatDate;
		},
		setOrderStatus() {
			const _this = this;
			_this.orderStatusList = Object.values(CONST.orderStatus);
		},
		getOrderStatus(itemIndex) {
			const _this = this;
			var item = _this.paymentResultList[itemIndex];
			var orderStatusName = CONST.orderStatus[item.ORDER_STATUS].name;

			return orderStatusName;
		},
		onOrderStatusChanged() {
			const _this = this;
			_this.loadPaymentResultList(1);
		},
		showPayInfo(itemIndex) {
			const _this = this;
			var item = _this.paymentResultList[itemIndex];

			var param = {
				orderKey : item.ORDER_KEY
			}

			if(item.ORDER_STATUS == "unpaid") {
				PAGES.popPage(PAGES.SUB_PAYMENT_FINAL_LIST,param);
			}else{
				PAGES.popPage(PAGES.SUB_PAYMENT_RESULT_VIEW,param);
			}
		  
		},
		loadPaymentResultList(pageNo) {
			const _this = this;
			var status = "";

			if(_this.orderStatus != "" && _this.orderStatus != undefined) {
				status = _this.orderStatus;
			}

			let param = {
				pPageNo: pageNo,
				pPageSize: _this.pageSize,
				pOrderStatus: status
			};

			API.ajaxRequest({
				url: API.getPaymentResultListUrl(),
				data: param
			}).then(function (data) {
				_this.pageNo = pageNo;

				if(pageNo == 1) {
					MODULE.Util.clearArray(_this.paymentResultList);
				}

				for(var i = 0; i < data.paymentResultList.length; i++) {
					var item = data.paymentResultList[i];

					_this.paymentResultList.push(item);
				}
				
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		}
 	
  }
}
</script>